module.exports = "/img/_/_/_/assets/images/creeper/book/epic//5.jpg?e06a4de97556e97d7eabb3815d3faaec";